export default class Tenant {
    static readonly accountantTenant = new Tenant('accountant', '38bc24a6-9b31-4145-92cf-d280c46f807a', 'Contador');
    static readonly organizationTenant = new Tenant('organization', 'd2cbfe38-9803-4da0-8e2c-4e67f26ba9f5', 'Empresa');
    static readonly salesTenant = new Tenant('sales', '55a6447d-712e-4614-8fcc-6f6bc487f3f7', 'Vendas');

    static readonly All = [
        Tenant.accountantTenant,
        Tenant.organizationTenant,
        Tenant.salesTenant
    ];

    constructor(readonly name: string, readonly id: string, readonly label: string) {}
}